import { createStore } from 'satcheljs';

export const getStore = createStore<{
    isDraggingCalendarItem: boolean;
}>('calendarDateGridDnDStore', {
    isDraggingCalendarItem: false,
});
